<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="1500"
    scrollable
    @keydown.esc="closeButtonClickEvent"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>複写する受注を選択</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text class="px-2 card-layer my-2">
        <v-card flat>
          <v-card-subtitle class="px-2">
            <!-- 検索ブロック -->
            <v-expansion-panels v-model="panel" accordion>
              <v-expansion-panel>
                <v-expansion-panel-header class="panel-header-color panel-selectable">
                  <strong>
                    <v-icon class="panel-header-color">
                      mdi-magnify
                    </v-icon>
                    &nbsp;条件を指定して検索
                  </strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-card-text>

                      <!-- 取引先（排出）事業者, 取引先（排出）事業場, 運搬担当者 -->
                      <infinite-emission-and-location-auto-complete
                        :supplier-id="conditions.supplier_id"
                        :location-id="conditions.supplier_location_id"
                        :location-code="conditions.supplier_location_code"
                        :without-general-form="false"
                        :without-invisible="true"
                        supplier-md="5"
                        location-md="4"
                        supplier-label="取引先（排出事業者）"
                        location-label="取引先事業場"
                        classes="search-font"
                        rounded
                        @update:values="supplierChangeCallback"
                      >
                        <template v-slot:supplier-append-outer>
                          <v-btn
                            class="primary"
                            small
                            @click="showEmissionModalButtonClickEvent"
                          >
                            取引先を選択
                          </v-btn>
                          <choose-emission-modal
                            :enable="showEmissionModal"
                            :without-general-form="false"
                            @selected="choseSupplierCallback"
                            @close="closeDialog"
                          />
                        </template>
                        <template v-slot:location-item="slotProps">
                          <v-chip
                            :title="slotProps.item?.code"
                            color="#e0ffff"
                            label
                            small
                          >
                            {{ slotProps.item?.code }}
                          </v-chip>
                          &nbsp;{{ slotProps.item.text }}
                          <small class="text--disabled">{{ slotProps.item.address }}</small>
                        </template>
                        <template v-slot:append>
                          <v-col cols="12" md="3">
                            <v-select
                              v-model="conditions.report_transport_user_id"
                              :items="drivers"
                              clearable
                              dense
                              hide-details="auto"
                              label="運搬担当者"
                              outlined
                              rounded
                              persistent-placeholder
                              class="search-font"
                              @change="transportUserChangeEvent"
                              @click:clear="clearEvent('report_transport_user_name')"
                            />
                          </v-col>
                        </template>
                      </infinite-emission-and-location-auto-complete>
                      <!-- /取引先, 取引先事業場, 運搬担当者 -->

                      <!-- 運搬先（収運・処分）事業者, 運搬先（収運・処分）事業場 -->
                      <infinite-trader-and-location-auto-complete
                        :trader-id="conditions.supplier_trader_id"
                        :location-id="conditions.supplier_trader_location_id"
                        :location-code="conditions.supplier_trader_location_code"
                        :include-general-waste-disposer="true"
                        trader-md="5"
                        location-md="4"
                        trader-label="運搬先（収運・処分事業者）"
                        location-label="運搬先事業場"
                        classes="search-font"
                        rounded
                        search-type="either"
                        @update:values="supplierTraderChangedCallback"
                      >
                        <template v-slot:location-item="slotProps">
                          <v-chip
                            :title="slotProps.item?.code"
                            color="#e0ffff"
                            label
                            small
                          >
                            {{ slotProps.item?.code }}
                          </v-chip>
                          &nbsp;{{ slotProps.item.text }}
                          <small class="text--disabled">{{ slotProps.item.address }}</small>
                        </template>
                        <template v-slot:trader-append-outer>
                          <v-btn
                            color="primary"
                            small
                            @click="showTraderModalButtonClickEvent"
                          >
                            運搬先を選択
                          </v-btn>
                          <choose-trader-modal
                            :enable="showTraderModal"
                            :include-general-waste-disposer="true"
                            @close="closeDialog"
                            @selected="choseTransportCallback"
                          />
                        </template>
                      </infinite-trader-and-location-auto-complete>
                      <!-- /運搬先（収運・処分）事業者, 運搬先（収運・処分）事業場 -->

                      <!-- 回収日, 終了日, DXE起票担当者, DXE起票担当者, 品目 -->
                      <v-row>
                        <v-col cols="12" md="2">
                          <cs-date-picker
                            :date.sync="conditions.collected_start_date"
                            @dateChangedCallback="(date) => { conditions.collected_start_date = date; searchButtonClickEvent(); }"
                          >
                            <template v-slot="{ on, attrs }">
                              <v-text-field
                                v-model="conditions.collected_start_date"
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                dense
                                hide-details="auto"
                                label="回収日"
                                outlined
                                persistent-hint
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                class="search-font"
                                @click:clear="conditions.collected_start_date = null; searchButtonClickEvent()"
                              >
                                <template v-slot:append-outer>
                                <span
                                  v-if="$vuetify.breakpoint.mdAndUp"
                                  style="margin-top: 3px;"
                                >
                                  &nbsp;〜
                                </span>
                                </template>
                              </v-text-field>
                            </template>
                          </cs-date-picker>
                        </v-col>
                        <v-col cols="12" md="2">
                          <cs-date-picker
                            :date.sync="conditions.collected_end_date"
                            @dateChangedCallback="(date) => { conditions.collected_end_date = date; searchButtonClickEvent(); }"
                          >
                            <template v-slot="{ on, attrs }">
                              <v-text-field
                                v-model="conditions.collected_end_date"
                                v-bind="attrs"
                                v-on="on"
                                clearable
                                dense
                                hide-details="auto"
                                label="終了日"
                                outlined
                                persistent-hint
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                class="search-font"
                                @click:clear="conditions.collected_end_date = null; searchButtonClickEvent()"
                              >
                                <template v-slot:append-outer>&emsp;</template>
                              </v-text-field>
                            </template>
                          </cs-date-picker>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-combobox
                            v-model="conditions.vote_staff"
                            :items="voteStaffs"
                            :return-object="false"
                            dense
                            label="DXE起票担当者"
                            hide-details="auto"
                            outlined
                            clearable
                            rounded
                            persistent-placeholder
                            class="search-font"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col cols="12" md="4">
                          <item-autocomplete
                            v-model="conditions.item_ids"
                            :items="items"
                            classes="search-font"
                            clearable
                            dense
                            label="JWNET取扱品目"
                            persistent-placeholder
                            outlined
                            rounded
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                      </v-row>
                      <!-- /受注種別, 回収日, 終了日, DXE起票担当者, 品目 -->

                      <!-- 受注番号, 依頼番号有無, 依頼番号, 取引番号有無, 取引番号 -->
                      <v-row>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="conditions.order_number"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="受注番号"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            class="search-font"
                            @blur="handleSearch"
                            @click:clear="clearEvent('order_number')"
                          />
                        </v-col>

                        <v-col cols="12" md="2">
                          <v-select
                            v-model="conditions.request_number_flag"
                            :items="requestNumberFlags"
                            clearable
                            dense
                            hide-details="auto"
                            label="依頼番号有無"
                            outlined
                            persistent-placeholder
                            rounded
                            class="search-font"
                            @change="handleSearch"
                          />
                        </v-col>

                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="conditions.request_number"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="依頼番号"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            class="search-font"
                            @blur="handleSearch"
                            @click:clear="clearEvent('request_number')"
                          />
                        </v-col>

                        <v-col
                          v-if="isBilling"
                          cols="12" md="2"
                        >
                          <v-select
                            v-model="conditions.deal_number_flag"
                            :items="dealNumberFlags"
                            dense
                            hide-details="auto"
                            label="取引番号有無"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            class="search-font"
                            @change="handleSearch"
                          />
                        </v-col>

                        <v-col
                          v-if="isBilling"
                          cols="12" md="2"
                        >
                          <v-text-field
                            v-model="conditions.deal_number"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="取引番号"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            class="search-font"
                            @blur="handleSearch"
                            @click:clear="clearEvent('deal_number')"
                          />
                        </v-col>

                        <v-col
                          cols="12" md="2"
                        >
                          <v-text-field
                            v-model="conditions.waste_name"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="廃棄物の名称"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            class="search-font"
                            @blur="handleSearch"
                            @click:clear="clearEvent('waste_name')"
                          />
                        </v-col>
                      </v-row>
                      <!-- /受注番号, 依頼番号有無, 依頼番号, 取引番号有無, 取引番号 -->

                      <!-- 受注種別, マニフェスト区分（産廃回収・排出持込）, 運搬先を検索, 検索キーワード -->
                      <v-row>
                        <v-col cols="12" md="2">
                          <v-select
                            v-model="conditions.order_type"
                            :items="orderTypes"
                            dense
                            hide-details="auto"
                            label="受注種別"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            class="search-font"
                            @change="handleSearch"
                          />
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-select
                            v-model="conditions.manifest_type"
                            :items="manifestTypes"
                            dense
                            hide-details="auto"
                            label="マニフェスト区分（産廃回収・排出持込）"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            class="search-font"
                            @change="handleSearch"
                          />
                        </v-col>

                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="conditions.keyword"
                            prepend-inner-icon="mdi-magnify"
                            background-color="white"
                            dense
                            hide-details="auto"
                            outlined
                            rounded
                            placeholder="運搬先を検索"
                            class="search-font"
                            clearable
                            @blur="handleSearch"
                            @click:clear="clearEvent('keyword')"
                          />
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="conditions.search_keyword"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="検索キーワード"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            class="search-font"
                            @blur="handleSearch"
                            @click:clear="clearEvent('search_keyword')"
                          />
                        </v-col>

                      </v-row>
                      <!-- /受注種別, マニフェスト区分（産廃回収・排出持込）, 運搬先を検索, 検索キーワード -->

                      <!-- 排出事業場コード, 排出事業場名称, ドライバー -->
                      <v-row>
                        <!-- 排出事業場コード -->
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="conditions.location_code"
                            dense hide-details="auto"
                            label="排出事業場コード"
                            clearable
                            outlined
                            persistent-placeholder
                            placeholder="例）K001"
                            rounded
                            @blur="handleSearch"
                            class="search-font"
                            @click:clear="clearEvent('location_code')"
                          />
                        </v-col>
                        <!-- /排出事業場コード -->
                        <!-- 排出事業場名称 -->
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="conditions.location_name"
                            dense hide-details="auto"
                            label="排出事業場名称"
                            clearable outlined
                            persistent-placeholder
                            placeholder="部分一致で検索"
                            rounded
                            class="search-font"
                            @blur="handleSearch"
                            @click:clear="clearEvent('location_name')"
                          />
                        </v-col>
                        <!-- /排出事業場名称 -->
                        <v-col cols="12" md="4">
                          <v-select
                            v-model="conditions.driver_id"
                            :items="drivers"
                            clearable
                            dense
                            hide-details="auto"
                            label="ドライバー"
                            outlined
                            rounded
                            persistent-placeholder
                            @change="driverChangeEvent"
                            class="search-font"
                            @click:clear="clearEvent(['driver_id', 'driver_name'])"
                          />
                        </v-col>

                      </v-row>

                    </v-card-text>
                  </v-card>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="searchAndClosePanel">
                      検索
                    </v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- /検索ブロック -->
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card-text>
                  <v-data-table
                    :headers="isBilling ? billingTableHeaders : tableHeaders"
                    :items="orders"
                    :items-per-page="-1"
                    dense
                    hide-default-footer
                    single-select
                    disable-sort
                    @click:row="rowClickEvent"
                    @dblclick:row="rowDoubleClickEvent"

                  >
                    <!-- ステータス -->
                    <template v-slot:[`item.status`]="{ item }">
                      <v-chip
                        x-small
                        label
                        :color="item.status | status_chip_order_color(item.order_type)"
                      >
                        {{ item.status | status_to_label_accept(item.order_type, isAllocate) }}
                      </v-chip>
                    </template>
                    <!-- ステータス -->
                    <!-- オーダー番号/受注日 -->
                    <template v-slot:[`item.order_no`]="{ item }">
                      <div>
                        {{ item.order_no }}&nbsp;
                      </div>
                      <small class="text--disabled">{{ item.order_date | date_format }}</small>
                    </template>
                    <!-- /オーダー番号/受注日 -->
                    <!-- 依頼番号/依頼日 -->
                    <template v-slot:[`item.request_no`]="{ item }">
                      <div>
                        {{ item.request_no }}&nbsp;
                      </div>
                      <span v-if="item.request_no">
                        <small class="text--disabled">{{ item.created_at | unix_date_format }}</small>
                      </span>
                    </template>
                    <!-- 依頼番号/依頼日 -->

                    <!-- 回収/搬入/引取日 -->
                    <template v-slot:[`item.target_date`]="{ item }">
                      <span v-if="item.target_urgent && !item.target_date">至急</span>
                      <span v-else>
                        <span v-if="item.target_date">
                          <span v-if="item.past_manifest" style="color: #3cbf91">
                            ●
                          </span>
                          <small>{{ item.target_date | date_format }}</small>
                        </span>
                      </span>
                    </template>
                    <!-- /回収日 -->

                    <!-- 取引先（事業者） -->
                    <template v-slot:[`item.supplier`]="{ item }">
                      <div>
                        <div class="inline-flex-container">
                          <div
                            :title="item.supplier.name"
                            class="line-clamp one-clamp"
                          >
                            {{ item.supplier.name }}
                          </div>
                          <v-tooltip top :open-on-hover="false">
                            <template #activator="{ on }">
                              <v-btn
                                icon
                                tile
                                small
                                retain-focus-on-click
                                class="map-icon"
                                @click="on.click"
                                @blur="on.blur"
                              >
                                <v-icon small>mdi-map-marker-outline</v-icon>
                              </v-btn>
                            </template>
                            <div>
                              <strong>{{ item.supplier.name }}</strong>
                              <br />
                              <small>{{ item.supplier.address }}</small>
                            </div>
                          </v-tooltip>
                        </div>
                      </div>
                      <div>
                        <div class="inline-flex-container">
                          <div
                            :title="item.supplier_location.name"
                            class="line-clamp one-clamp"
                          >
                            {{ item.supplier_location.name }}
                          </div>
                          <v-tooltip top :open-on-hover="false">
                            <template #activator="{ on }">
                              <v-btn
                                v-if="item.supplier_location.name"
                                icon
                                tile
                                small
                                retain-focus-on-click
                                class="map-icon"
                                @click="on.click"
                                @blur="on.blur"
                              >
                                <v-icon small>mdi-map-marker-outline</v-icon>
                              </v-btn>
                            </template>
                            <div>
                              <strong>{{ item.supplier_location.name }}</strong>
                              <br />
                              <small>{{ item.supplier_location.address }}</small>
                            </div>
                          </v-tooltip>
                        </div>
                      </div>
                    </template>
                    <!-- /取引先（事業者） -->
                    <!-- 運搬先 -->
                    <template v-slot:[`item.destination`]="{ item }">
                      <div
                        v-if="item.destination_location"
                        :title="item.destination_location.name"
                        class="line-clamp one-clamp"
                      >
                        {{ item.destination_location.name }}
                      </div>
                    </template>
                    <!-- /運搬先 -->
                    <!-- 品目 -->
                    <template v-slot:[`item.item_name`]="{ item }">
                      <div v-if="item.item_name">
                        <v-chip
                          :title="item.item_name"
                          color="#F0E6D0"
                          drak
                          label
                          x-small
                        >
                          {{ item.item_name | truncate(10) }}
                        </v-chip>
                      </div>
                      <small
                      >{{ item.packing_name
                        }}<span v-if="item.total_items_count > 0"
                        >&emsp;全&nbsp;{{ item.total_items_count }}件</span
                        ></small
                      >
                    </template>
                    <!-- 品目 -->
                  </v-data-table>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-pagination
                  v-model="page"
                  :length="pagination.total_pages"
                  :total-visible="totalVisible"
                  circle
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="pageChangeEvent"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
          @mousedown.prevent
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          :disabled="selectedRow === null"
          @click="registerButtonClickEvent"
        >
          複写して作成
        </v-btn>
        <v-snackbar v-model="snackbar" color="red accent-2" :timeout="timeout">
          {{ message }}

          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import ChooseTraderModal from "@/driver/components/ChooseTraderModal.vue";
import InfiniteTraderAndLocationAutoComplete from "@/driver/components/InfiniteTraderAndLocationAutoComplete.vue";
import InfiniteEmissionAndLocationAutoComplete from "@/driver/components/InfiniteEmissionAndLocationAutoComplete.vue";
import ChooseEmissionModal from "@/driver/components/ChooseEmissionModal.vue";
import {clear} from "core-js/internals/task";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: 'DuplicateOrderDialog',
  components: {
    ChooseEmissionModal,
    InfiniteEmissionAndLocationAutoComplete,
    InfiniteTraderAndLocationAutoComplete,
    ChooseTraderModal,
    ItemAutocomplete,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    voteStaffs: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      panel: [],
      page: 1,
      totalVisible: 7,
      showEmissionModal: false,
      showTraderModal: false,
      conditions: {
        /* 取引先（排出）事業者ID */
        supplier_id: null,
        supplier_type: null,
        /* 取引先（排出）事業場ID */
        supplier_location_id: null,
        /* 取引先（排出）事業場コード */
        supplier_location_code: null,
        /* 運搬担当者 */
        report_transport_user_id: null,
        report_transport_user_name: null,
        /* 取引先（収運・処分）業者ID */
        supplier_trader_id: null,
        supplier_trader_type: null,
        /* 取引先（収運・処分）事業場ID */
        supplier_trader_location_id: null,
        /* 取引先（収運・処分）事業場コード */
        supplier_trader_location_code: null,

        /* 回収(開始日) */
        collected_start_date: null,
        /* 回収(終了) */
        collected_end_date: null,
        /* DXE起票担当者 */
        vote_staff: null,
        /* JWNET取扱品目 */
        item_ids: [],

        /* 受注番号 */
        order_number: null,
        /* 依頼番号有無 */
        request_number_flag: null,
        /* 依頼番号 */
        request_number: null,
        /* 取引番号有無 */
        deal_number_flag: null,
        /* 取引番号 */
        deal_number: null,
        /* 廃棄物の名称 */
        waste_name: null,

        /* 受注種別 */
        order_type: null,
        /* マニフェスト区分 */
        manifest_type: null,
        /* 運搬先 */
        keyword: null,
        /* 検索キーワード */
        search_keyword: null,

        /* 排出事業場コード */
        location_code: null,
        /* 排出事業場名 */
        location_name: null,
        /* ドライバー */
        driver_id: null,
        driver_name: null,

      },
      orders: [],
      selectedRow: null,
      billingTableHeaders: [
        { text: 'ステータス', value: 'status', width: '12%', align: 'center' },
        { text: '受注番号\r\n受注日', value: 'order_no', align: 'center', width: '8%' },
        { text: '依頼番号\r\n依頼日', value: 'request_no', align: 'center', width: '8%' },
        { text: '回収・積替・搬入日 ', value: 'target_date', align: 'center', width: '14%' },
        { text: '取引先（事業者）\r\n取引先（事業場）', value: 'supplier', width: '21%' },
        { text: '運搬先', value: 'destination', width: '21%' },
        { text: '品目\r\n荷姿', value: 'item_name', width: '10%' },
        { text: '取引番号', value: 'deal_no', width: '6%' },
      ],
      /*  */
      tableHeaders: [
        { text: 'ステータス', value: 'status', width: '14%' },
        { text: '受注番号\r\n受注日', value: 'order_no', align: 'center', width: '8%' },
        { text: '依頼番号\r\n依頼日', value: 'request_no', align: 'center', width: '8%' },
        { text: '回収・積替・搬入日 ', value: 'target_date', align: 'center', width: '14%' },
        { text: '取引先（事業者）\r\n取引先（事業場）', value: 'supplier', width: '23%' },
        { text: '運搬先', value: 'destination', width: '23%' },
        { text: '品目\r\n荷姿', value: 'item_name', width: '10%', align: 'center' },
      ],
      /** 依頼番号有無 */
      requestNumberFlags: [
        { value: 'something', text: '有'},
        { value: 'nothing', text: '無' }
      ],
      /** 取引番号有無 */
      dealNumberFlags: [
        { value: 'something', text: '有'},
        { value: 'nothing', text: '無' },
        { value: 'not_sales', text: '計上しない' }
      ],
      /** マニフェスト区分 */
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' },
        { value: 'general_form', text: '一般廃棄物' },
      ],
      pagination: {
        current_page: 1,
        total_count: 0
      },
      /** 受注種別 */
      orderTypes: [
        { value: 'collection', text: '産廃回収' },
        { value: 'self_emission', text: '排出持込' },
        { value: "proxy_request", text: "他社運搬" },
        { value: "general", text: "一廃回収" },
        { value: 'carryin', text: '積替運搬' },
        { value: 'pickup', text: '搬入予約' },
      ],
      drivers: [],
      items: [],
      snackbar: false,
      message: null,
      timeout: 5000,
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isAllocate: "use_allocate",
      isBilling: 'use_billing',
    }),
  },
  watch: {
    enableDialog () {
      // 検索パネルを開いた状態にする
      this.panel = 0
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedRow = null
      this.orders = []
      Object.assign(this.$data.conditions, this.$options.data().conditions)
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      this.pagination = {current_page: 1,total_count: 0}
    },
  },
  created() {
    this.fetchDrivers().then((content) => {
      this.drivers = content.drivers;
    });
    this.fetchItems().then((content) => {
      this.items = content.items
    })
  },
  methods: {
    clear,
    ...mapActions('DriverOrderAcceptDuplicateOrder', {
      fetchDuplicateOrders: 'index',
    }),
    ...mapActions('DriverMasterSearchJipCode', {
      fetchJipCode: 'show'
    }),
    ...mapActions("DriverMasterSearchDriver", {
      fetchDrivers: "index",
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index',
    }),
    /**
     * 回収先（排出事業者・事業場） チェンジコールバック
     *
     * @param emission_id { Number } 排出事業者ID
     * @param location_id { Number } 排出事業場ID
     * @param location_code { String } 排出事業場コード
     */
    supplierChangeCallback (emission_id, location_id, location_code) {
      let changed = false;
      if (this.conditions.supplier_id !== emission_id) {
        changed = true;
      }

      if (this.conditions.supplier_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_id = emission_id;
      this.conditions.supplier_type = emission_id ? "Emission" : null;
      this.conditions.supplier_location_id = location_id;
      this.conditions.supplier_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }
    },
    /**
     * 排出事業者選択モーダル　コールバック
     * @param item
     */
    choseSupplierCallback(item) {
      this.conditions.supplier_id = item.id;
      this.conditions.supplier_location_id = null;
      this.conditions.supplier_location_code = null;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 回収先 収運・処分事業者チェンジ コールバック
     * @param trader_id { Number } 事業者ID
     * @param location_id { Number } 事業場ID
     * @param location_code { String } 事業場コード
     */
    supplierTraderChangedCallback (trader_id, location_id, location_code) {

      let changed = false;

      if (this.conditions.supplier_trader_id !== trader_id) {
        changed = true;
      }

      if (this.conditions.supplier_trader_location_id !== location_id) {
        changed = true;
      }

      this.conditions.supplier_trader_id = trader_id;
      this.conditions.supplier_trader_type = "Trader";
      this.conditions.supplier_trader_location_id = location_id;
      this.conditions.supplier_trader_location_code = location_code;

      if (changed) {
        this.$nextTick(() => { this.handleSearch(); })
      }

    },
    /**
     * 収運・処分業者選択モーダル コールバック
     * @param item
     */
    choseTransportCallback(item) {
      this.conditions.supplier_trader_id = item.id;
      this.conditions.supplier_trader_type = "Trader";
      this.conditions.supplier_trader_location_id = null;
      this.conditions.supplier_trader_location_code = null;
      this.$nextTick(() => { this.handleSearch(); })
      this.closeDialog();
    },
    /**
     * 取引先（排出）事業者 モーダル表示
     */
    showEmissionModalButtonClickEvent() {
      this.showEmissionModal = true;
    },
    showTraderModalButtonClickEvent() {
      this.showTraderModal = true;
    },

    closeDialog () {
      this.showEmissionModal = false;
      this.showTraderModal = false;
    },
    clearEvent (keys) {
      if (Array.isArray(keys)) {
        keys.forEach(key => this.conditions[key] = null);
      } else {
        this.conditions[keys] = null;
      }
      this.handleSearch();
    },

    pageChangeEvent () {
      this.searchOrders()
    },
    searchAndClosePanel() {
      if (this.selectedRow) {
        this.selectedRow.select(false)
        this.selectedRow = null
      }
      this.orders = []
      this.page = 1
      this.panel = []
      this.searchOrders()
    },
    searchButtonClickEvent () {
      if (this.selectedRow) {
        this.selectedRow.select(false)
        this.selectedRow = null
      }
      this.orders = []
      this.page = 1
      this.searchOrders()

    },
    transportUserChangeEvent(driver_id) {
      let driver = this.drivers.find((v) => v.value === driver_id);
      if (driver) {
        this.conditions.report_transport_user_name = driver.text
      }
      this.handleSearch();
    },
    driverChangeEvent(driver_id) {
      let driver = this.drivers.find((v) => v.value === driver_id);
      this.conditions.driver_name = driver.text
      this.handleSearch();
    },
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    registerButtonClickEvent () {
      let params = this.buildCheckParam()
      this.fetchJipCode({ params: params }).then((content) => {
        if (content.message) {
          this.message = content.message
          this.snackbar = true
        } else {
          this.$emit('registerCallback',  this.selectedRow.item)
        }
      })
    },
    buildCheckParam() {
      return {
        zip_code: this.selectedRow.item.zip_code,
        prefecture_code: this.selectedRow.item.prefecture_code,
        address_1: this.selectedRow.item.address_1,
        location_zip_code: this.selectedRow.item.location_zip_code,
        location_prefecture_code: this.selectedRow.item.location_prefecture_code,
        location_address_1: this.selectedRow.item.location_address_1,
      }
    },
    /**
     * 排出事業者行選択イベント
     * @param item
     * @param row
     */
    rowClickEvent (item, row) {
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("registerCallback", row.item);
    },
    handleSearch () {
      this.searchButtonClickEvent();
    },
    searchOrders () {
      if (!this.enableDialog) return false;

      this.fetchDuplicateOrders({ conditions: this.conditions, page: this.page }).then((content) => {
        this.orders = content.orders
        this.pagination = content.pagination
      })
    }
  }
}
</script>

<style scoped lang="scss">
.inline-flex-container {
  display: inline-flex;
  align-items: center;
  gap: 0;
  max-width: 100%;
}
.map-icon {
  flex-shrink: 0;
}
</style>
